import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../AppContext";
import useElementHeight from "../../hooks/useElementHeight";
import arrowLeft from "../../assets/arrow-left.svg";

const TITLE_SIZE = "18px";

const TITLE_VARIANTS = {
  default: {
    as: "h5",
    divider: true,
    style: { color: "#344054", fontWeight: 500, fontSize: TITLE_SIZE },
  },
  plain: {
    as: "h5",
    divider: false,
    style: { color: "#23272f", fontWeight: 800, fontSize: TITLE_SIZE },
  },
  brand: {
    as: "h2",
    divider: false,
    style: { color: "#469B12", fontWeight: 600, fontSize: TITLE_SIZE },
  },
};

const MobilePageShell = ({
  title,
  titleVariant = "default",
  titleAs,
  divider,
  onBack,
  sticky = true,
  bottomGap = 16,
  headerClassName = "d-flex align-items-center gap-3 px-3 py-3",
  headerWrapperClassName = "mb-4",
  headerAction,
  desktopClassName = "py-5",
  children,
  className = "",
  style = {},
}) => {
  const { isMobile } = useAppContext();
  const navigate = useNavigate();

  const topNavHeight = useElementHeight(".fixed-top", 56, isMobile);
  const bottomNavHeight = useElementHeight(".fixed-bottom", 72, isMobile);

  if (!isMobile) {
    return (
      <div className={`${desktopClassName} ${className}`.trim()} style={style}>
        {children}
      </div>
    );
  }

  const variant = TITLE_VARIANTS[titleVariant] || TITLE_VARIANTS.default;
  const Heading = titleAs || variant.as;
  const showDivider = divider === undefined ? variant.divider : divider;

  return (
    <div
      className={className}
      style={{
        paddingTop: `${topNavHeight}px`,
        paddingBottom: `${bottomNavHeight + bottomGap}px`,
        ...style,
      }}
    >
      {title && (
        <div
          className={headerWrapperClassName}
          style={{
            background: "#fff",
            ...(showDivider ? { borderBottom: "1px solid #DADADAB2" } : {}),
            marginBottom: "16px",
            ...(sticky
              ? {
                  position: "sticky",
                  top: `${topNavHeight}px`,
                  zIndex: 6,
                  boxShadow: "0 4px 10px rgba(0,0,0,.04)",
                }
              : {}),
          }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div className={headerClassName}>
              <img
                src={arrowLeft}
                alt="Back"
                onClick={onBack || (() => navigate(-1))}
                style={{ cursor: "pointer" }}
              />
              <Heading className="my-auto" style={variant.style}>
                {title}
              </Heading>
            </div>
            {headerAction}
          </div>
        </div>
      )}
      {children}
    </div>
  );
};

export default MobilePageShell;
